module.exports = __webpack_public_path__ + "static/media/pending-test-img.8e5104cc.png";